// extracted by mini-css-extract-plugin
export var button = "_pr-1";
export var container = "_pr-0";